import $ from 'jquery'
import '@bprogress/core/css'
import { BProgress } from '@bprogress/core'

window.BProgress = BProgress // loaded through sprockets, move to vite later

let disabled = null
// One way to disable Nprogress is by passing globals: false when you call $.ajax.
// However, that also disables *all* global events. Which in some cases is not desirable/possible
export const disableBProgressBarTemporarily = () => {
  disabled = true
  setTimeout(() => (disabled = false), 30)
}

export const startBProgressBar = () => {
  if (!disabled) BProgress.start()
}

export const doneBProgressBar = () => {
  BProgress.done()
}

if (BProgress) {
  BProgress.configure({ showSpinner: false, minimum: 0.2 })
  $(document).on('page:fetch', () => BProgress.start())
  $(document).on('page:change', () => BProgress.done())
  $(document).on('page:restore', () => {
    BProgress.done()
    BProgress.remove()
  })
  $(document).on('click', '[data-behavior=show-nprogress]', () =>
    BProgress.start()
  )
  $(document).ajaxStart(function (e) {
    if (document.body?.style != null && !disabled) {
      startBProgressBar()
    }
  })
  $(document).ajaxStop(function () {
    if (document.body?.style != null) {
      doneBProgressBar()
    }
  })
  window.Turbolinks?.ProgressBar?.disable()
}
